import React, { useState, useEffect } from 'react';

interface AnnouncementsManagementProps {
  token: string;
}

const CARD_STYLE = {
  background: 'white',
  padding: '24px',
  borderRadius: '14px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
  border: '1px solid #e2e8f0'
};

const AnnouncementsManagement: React.FC<AnnouncementsManagementProps> = ({ token }) => {
  const [announcements, setAnnouncements] = useState<any[]>([]);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('info');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const load = async () => {
    try {
      const res = await fetch('/api/announcements');
      if (res.ok) setAnnouncements(await res.json());
    } catch {}
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!title.trim() || !message.trim()) {
      setMsg('Title and message required');
      return;
    }
    setLoading(true);
    setMsg('');
    try {
      const res = await fetch('/api/admin/announcements', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ title, message })
      });
      if (res.ok) {
        setMsg('Announcement created!');
        setTitle('');
        setMessage('');
        load();
      } else {
        const d = await res.json();
        setMsg(d.error || 'Failed to create');
      }
    } catch {
      setMsg('Error creating announcement');
    }
    setLoading(false);
    setTimeout(() => setMsg(''), 3000);
  };

  const remove = async (id: string) => {
    if (!window.confirm('Delete this announcement?')) return;
    try {
      await fetch(`/api/admin/announcements/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      load();
    } catch {}
  };

  return (
    <div>
      <h2 style={{ fontSize: '20px', margin: '0 0 20px 0', color: '#0f172a' }}>Announcements</h2>

      <div style={{ ...CARD_STYLE, marginBottom: '24px' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '15px', color: '#0f172a' }}>Create Announcement</h3>

        <div style={{ marginBottom: '12px' }}>
          <label style={{ fontSize: '13px', fontWeight: 500, color: '#475569', display: 'block', marginBottom: '4px' }}>Title</label>
          <input value={title} onChange={e => setTitle(e.target.value)}
            placeholder="e.g. Scheduled Maintenance"
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: '12px' }}>
          <label style={{ fontSize: '13px', fontWeight: 500, color: '#475569', display: 'block', marginBottom: '4px' }}>Message</label>
          <textarea value={message} onChange={e => setMessage(e.target.value)}
            placeholder="Describe what users need to know..."
            rows={3}
            style={{ width: '100%', padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
        </div>

        <button onClick={create} disabled={loading}
          style={{ padding: '10px 20px', background: '#533afd', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>
          {loading ? 'Creating...' : 'Create Announcement'}
        </button>

        {msg && (
          <div style={{ marginTop: '12px', padding: '10px', borderRadius: '8px',
            background: msg.includes('created') ? '#d1fae5' : '#fee2e2',
            color: msg.includes('created') ? '#065f46' : '#991b1b', fontSize: '13px' }}>
            {msg}
          </div>
        )}
      </div>

      <div style={CARD_STYLE}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '15px', color: '#0f172a' }}>
          Active Announcements ({announcements.length})
        </h3>

        {announcements.length === 0 ? (
          <p style={{ color: '#94a3b8', fontSize: '14px' }}>No announcements yet. Create one above.</p>
        ) : (
          announcements.map(a => (
            <div key={a.id} style={{
              padding: '16px', borderRadius: '10px', marginBottom: '12px',
              border: '1px solid #e2e8f0',
              background: a.type === 'warning' ? '#fffbeb' : a.type === 'error' ? '#fef2f2' : '#f0f9ff'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                <div>
                  <strong style={{ fontSize: '14px', color: '#0f172a' }}>{a.title || 'Untitled'}</strong>
                  {a.type && <span style={{
                    marginLeft: '8px', padding: '1px 8px', borderRadius: '10px', fontSize: '11px',
                    background: a.type === 'warning' ? '#fef3c7' : a.type === 'error' ? '#fee2e2' : '#e0f2fe',
                    color: a.type === 'warning' ? '#92400e' : a.type === 'error' ? '#991b1b' : '#0369a1'
                  }}>{a.type}</span>}
                </div>
                <button onClick={() => remove(a.id)}
                  style={{ padding: '4px 10px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: '#dc2626' }}>
                  Delete
                </button>
              </div>
              <p style={{ margin: 0, fontSize: '13px', color: '#475569', whiteSpace: 'pre-wrap' }}>{a.message}</p>
              <div style={{ marginTop: '8px', fontSize: '11px', color: '#94a3b8' }}>
                {a.created_at ? new Date(a.created_at).toLocaleString('en-GB') : ''}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AnnouncementsManagement;
